import { render, staticRenderFns } from "./CrossmatchReport.vue?vue&type=template&id=f0329b96&"
import script from "./CrossmatchReport.vue?vue&type=script&lang=ts&"
export * from "./CrossmatchReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports